export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=6c9e70db&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/competencies/index.vue?vue&type=template&id=6c9e70db&
// module id = 1416
// module chunks = 0